import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as summaryReportAction from "../../../store/summary-report/action";

import { Col, Input, Table } from "reactstrap";
import React, { useEffect, useMemo, useState } from "react";

import { GET_RP_BALANCE } from "helpers/url_api_constant";
import PropTypes from "prop-types";
import {SHIPPER_COLOR_LIST} from "../../../constants/constants";
import debounce from "lodash.debounce";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function Balancing(props) {
  const dispatch = useDispatch();

  function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }


  const [dataOnshoreBalancing, setDataOnshoreBalancing] = useState([]);

  useEffect(
    function () {
      fetchDataOnshoreBalancing();
    },
    [props.summaryReportPid, props.shipperList]
  );

  const setDispatchAction = useMemo(
    () =>
      debounce(value => {
        dispatch(summaryReportAction.setBalancingToState(value));
      }, 300),
    []
  );

  useEffect(() => {
    setDispatchAction(dataOnshoreBalancing);
  }, [dataOnshoreBalancing]);

  // useEffect(
  //     function () {
  //         dispatch(summaryReportAction.setBalancingToState(dataOnshoreBalancing));
  //         // dispatch()
  //     },
  //     [dataOnshoreBalancing]
  // );

  const shipperColor = [...SHIPPER_COLOR_LIST];

  const fetchDataOnshoreBalancing = async (fromManageGraph = false) => {
    dispatch(loadingAction.showLoading());
    try {
      let [onshoreBalancing] = await Promise.all([
        post(GET_RP_BALANCE, {
          SUMMARYREPORT_PID:
            props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        }),
      ]);
      onshoreBalancing = onshoreBalancing.data.rpBalancingList.sort((a, b) =>
        a.BALANCECOLUMN_ORDER > b.BALANCECOLUMN_ORDER
          ? 1
          : b.BALANCECOLUMN_ORDER > a.BALANCECOLUMN_ORDER
          ? -1
          : 0
      );

      setDataOnshoreBalancing(onshoreBalancing);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  return (
    <Col lg="6">
      <div>
      {/* className="table-responsive" */}
        <Table className="table table-bordered mb-0">
          <thead>
            <tr>
              <th
                colSpan={5}
                style={{
                  backgroundColor: "#556ee64a",
                  color: "#2FA3FF",
                  textAlign: "center",
                }}
              >
                {" "}
                Onshore Balancing
              </th>
            </tr>
            <tr>
              <th
                style={{
                  backgroundColor: "#556ee64a",
                  color: "#2FA3FF",
                  textAlign: "center",
                  width: "20%",
                }}
              ></th>
              <th
                style={{
                  backgroundColor: "#556ee678",
                  color: "#2FA3FF",
                  textAlign: "center",
                  width: "20%",
                }}
              >
                Zone
              </th>
              <th
                style={{
                  backgroundColor: "#667eef85",
                  color: "#2FA3FF",
                  textAlign: "center",
                  width: "20%",
                }}
              >
                Entry
              </th>
              <th
                style={{
                  backgroundColor: "#5868b785",
                  color: "#2FA3FF",
                  textAlign: "center",
                  width: "20%",
                }}
              >
                Exit
              </th>
              <th
                style={{
                  backgroundColor: "#515c9385",
                  color: "#2FA3FF",
                  textAlign: "center",
                  width: "20%",
                }}
              >
                Balancing
              </th>
            </tr>
          </thead>
          <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
            {props.shipperList.map((shipper,index) => {
              return (
                <React.Fragment key={shipper.PID + "shipper"}>
                  <tr>
                    <td
                      rowSpan={
                        dataOnshoreBalancing.filter(
                          row => row.BALANCECOLUMN_PID == shipper.PID
                        ).length + 2
                      }
                      style={{
                        textAlign: "center",
                        backgroundColor: shipperColor[index],//"#3CACFF", //"#ff7c4382"
                      }}
                    >
                      {shipper.SHIPPER_NAME}
                    </td>
                  </tr>
                  {dataOnshoreBalancing
                    .filter(row => row.BALANCECOLUMN_PID == shipper.PID)
                    .sort(
                      (a, b) =>
                        parseFloat(a.PRIORITY_FLAG) -
                        parseFloat(b.PRIORITY_FLAG)
                    )

                    .map(row => {
                      return (
                        <React.Fragment key={row.PID + "detail"}>
                          <tr
                            style={{
                              backgroundColor:
                                row.BALANCING_ZONE.toLowerCase() == "total"
                                  ? "#556ee630"
                                  : "",
                            }}
                          >
                            <td>{row.BALANCING_ZONE}</td>
                            <td>{numberFormat(row.BALANCING_ENTRY/1000, 2)}</td>
                            <td>{numberFormat(row.BALANCING_EXIT/1000, 2)}</td>
                            <td>{numberFormat(row.BALANCING_BALANCE, 2)} %</td>
                          </tr>
                          {row.BALANCING_ZONE.toLowerCase() == "total" && (
                            <tr>
                              <td>Remark</td>
                              <td colSpan={3}>
                                <Col sm={12}>
                                  <Input
                                    placeholder="-"
                                    type="textarea"
                                    rows="3"
                                    style={{
                                      border: "solid 1px #FFFFFF",
                                      color: "#FFFFFF",
                                    }}
                                    className="form-control"
                                    value={row.BALANCING_REMARK}
                                    onChange={e => {
                                      setDataOnshoreBalancing(prev => {
                                        return prev.map(obj => {
                                          if (obj.PID == row.PID) {
                                            obj.BALANCING_REMARK =
                                              e.target.value;
                                          }
                                          return obj;
                                        });
                                      });
                                    }}
                                  />
                                </Col>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                </React.Fragment>
              );
            })}
          </tbody>
        </Table>
      </div>
    </Col>
  );
}

Balancing.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
  shipperList: PropTypes.any,
};

export default Balancing;
